
export enum DisputeReassignReasonCd {
	CLAIM_GRAB_IN_ERROR_REASSIGN_TO_VALID_AUDITOR = 'ClaimGrabInErrorReassignToValidAuditor',
	EMPLOYEE_NO_LONGER_WITH_XPO = 'EmployeeNoLongerWithXpo',
	OTHER = 'Other',
	REALLOCATE_WORKLOAD = 'ReallocateWorkload'}

